import { Components as JoyComponents, Theme as JoyTheme } from '@mui/joy';
import JoyLink, { LinkProps as JoyLinkProps, linkClasses } from '@mui/joy/Link';
import JoyTypography, {
  TypographyProps as JoyTypographyProps,
} from '@mui/joy/Typography';
import { forwardRef } from 'react';
import {
  LinkProps as ReactRouterLinkProps,
  NavLink as ReactRouterNavLink,
  To as ReactRouterTo,
} from 'react-router-dom';

type OwnProps = { href: ReactRouterTo } & Omit<ReactRouterLinkProps, 'to'>;
export type LinkProps = OwnProps &
  Omit<JoyLinkProps, keyof Omit<ReactRouterLinkProps, 'color'> | 'href'>;

export const overrides: JoyComponents<JoyTheme> = {
  JoyLink: {
    styleOverrides: {
      root: () => ({
        [`& .MuiSvgIcon-root, & .${linkClasses.startDecorator} > svg`]: {
          margin: 'var(--Icon-margin)',
          fontSize: 'var(--Icon-fontSize, var(--joy-fontSize-xl2))',
          color:
            'var(--Icon-color, var(--joy-palette-text-icon, var(--joy-palette-neutral-500, #636B74)))',
        },
      }),
    },
  },
};
const Link = forwardRef(function Link(
  {
    href,
    replace,
    reloadDocument,
    state,
    preventScrollReset,
    relative,
    color = 'neutral',
    underline = 'none',
    ...props
  }: LinkProps,
  ref: React.ForwardedRef<HTMLAnchorElement>,
) {
  return (
    <JoyLink
      component={ReactRouterNavLink}
      {...props}
      color={color}
      underline={underline}
      to={href}
      replace={replace}
      state={state}
      preventScrollReset={preventScrollReset}
      relative={relative}
      reloadDocument={reloadDocument}
      ref={ref}
    />
  );
});
Link.displayName = 'Link';
export { Link };

type TextLinkProps = LinkProps & Omit<JoyTypographyProps, keyof LinkProps>;
const TextLink = forwardRef<HTMLAnchorElement, TextLinkProps>(function (
  {
    href,
    replace,
    reloadDocument,
    state,
    preventScrollReset,
    relative,
    slotProps,
    ...props
  },
  ref,
) {
  return (
    <JoyTypography
      {...props}
      underline='hover'
      component={Link}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      slotProps={slotProps}
      href={href}
      replace={replace}
      state={state}
      preventScrollReset={preventScrollReset}
      relative={relative}
      reloadDocument={reloadDocument}
      ref={ref}
    />
  );
});
TextLink.displayName = 'TextLink';
export { TextLink };
